import React from 'react';
import PropTypes from 'prop-types';

import CustomTable from '../../../../components/presentational/ControlCenterTable';
import Paginator from '../../../../components/presentational/Pagination';
import SearchBar from '../Customers/SearchBar';
import { ORG_HEADERS, orgToTable, ORG_ORDER_FIELDS } from '../Customers/mappers';
import colors from '../../../../styles/colors';
import ButtonText from '../../../../components/presentational/ButtonText/ButtonText';

const SEARCH_BY_OPTIONS = [
  { key: 'all', text: 'All', value: 'all' },
  { key: 'parent', text: 'Parent Name', value: 'parent' },
  { key: 'name', text: 'Name of site', value: 'name' },
  { key: 'address', text: 'Address', value: 'address' },
  { key: 'city', text: 'City', value: 'city' },
  { key: 'state', text: 'State', value: 'state' },
  { key: 'customer', text: 'Trilogy Customer #', value: 'customer' },
  { key: 'siteId', text: 'Trilogy Site ID', value: 'siteId' }
];

const ListView = ({
  selectItem,
  listResults,
  onSearch,
  filterValue,
  setFilterValue,
  filterName,
  setFilterName,
  onSort,
  orderBy,
  setCreate
}) => {
  const search = (name, value) => {
    const params = value ? { search: { name, value } } : {};
    onSearch(params, 1);
  };

  const paginate = (type, page) => {
    const params = filterValue ? { search: { name: filterName, value: filterValue } } : {};
    onSearch(params, page, type);
  };

  return (
    <>
      <SearchBar
        search={search}
        setName={setFilterName}
        setValue={setFilterValue}
        name={filterName}
        value={filterValue}
        dropdownOption={SEARCH_BY_OPTIONS}
      />
      {listResults && listResults.data && (
        <div className="list-container fade">
          <div style={styles.tableOptionsContainer}>
            <h2>Organizations: ({listResults.total})</h2>
            <ButtonText
              className="formulary-link"
              customStyles={styles.refreshAddressesButton}
              onClick={() => setCreate(true)}
            >
              <span className="button__text">Create Org</span>
            </ButtonText>
          </div>
          <CustomTable
            headers={ORG_HEADERS}
            onSort={onSort}
            orderBy={orderBy}
            availablesOrders={ORG_ORDER_FIELDS}
            className="sortable"
            data={listResults.data.map(row => ({
              cells: orgToTable(row),
              onSelect: () => selectItem(row)
            }))}
          />
          <Paginator
            onNext={() => paginate('orgs', listResults.currentPage + 1)}
            onPrev={() => paginate('orgs', listResults.currentPage - 1)}
            page={listResults.currentPage}
            totalPages={listResults.totalPages}
          />
        </div>
      )}
    </>
  );
};

const styles = {
  tableOptionsContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  refreshAddressesButton: {
    backgroundColor: colors.blueThree,
    color: colors.white,
    marginLeft: '1em',
    padding: '0 1em',
    width: 'auto'
  }
};

ListView.defaultProps = {
  onSort: () => {},
  orderBy: null
};

ListView.propTypes = {
  selectItem: PropTypes.func.isRequired,
  listResults: PropTypes.object.isRequired,
  onSearch: PropTypes.func.isRequired,
  filterValue: PropTypes.string.isRequired,
  setFilterValue: PropTypes.func.isRequired,
  filterName: PropTypes.string.isRequired,
  setFilterName: PropTypes.func.isRequired,
  onSort: PropTypes.func,
  orderBy: PropTypes.string,
  setCreate: PropTypes.func.isRequired
};

export default ListView;
